export const languages = {
    es: 'es',
    en: 'en',
};
